import { useMemo } from "react";

import { useUserData } from "../../../../../hooks/useUserData";

import { createVerificationState } from "../utils/verification";

export const usePdfVerification = ({ selectedVideos }) => {
  const { userData } = useUserData();

  const credits = userData?.reportCredits || 0;

  const selectedTableData = useMemo(() => {
    if (!selectedVideos) return [];
    return Object.values(selectedVideos);
  }, [selectedVideos]);

  const verificationAnalysed = useMemo(
    () =>
      selectedTableData.map((el) =>
        Object.keys(el?.analysis).length > 0 ? true : false
      ),
    [selectedTableData]
  );

  const verificationCameraAngles = useMemo(
    () =>
      selectedTableData?.map((el) =>
        el.metaData.cameraAngle === "DownTheLine" ||
        el.metaData.cameraAngle === "Down the Line (DTL)" ||
        el.metaData.cameraAngle === "DTL"
          ? "DTL"
          : "FO"
      ),
    [selectedTableData]
  );

  const verificationClubs = useMemo(
    () => selectedTableData?.map((el) => el.userData.golfClub),
    [selectedTableData]
  );
  const verificationUsers = useMemo(
    () => selectedTableData?.map((el) => el.userData.fullName),
    [selectedTableData]
  );

  const verificationState = useMemo(
    () =>
      createVerificationState(
        credits,
        verificationUsers,
        verificationClubs,
        verificationAnalysed,
        verificationCameraAngles
      ),
    [
      credits,
      verificationUsers,
      verificationClubs,
      verificationAnalysed,
      verificationCameraAngles,
    ]
  );

  return {
    credits,
    selectedTableData,
    verificationAnalysed,
    verificationCameraAngles,
    verificationClubs,
    verificationState,
    verificationUsers,
  };
};
